import { EventEmitter } from 'events';
import { Realtime } from './Realtime';
import { Orderbook } from './Orderbook';

export class Bitmex extends EventEmitter {
  private realtime: Realtime;
  private orderbook = new Orderbook();
  private ticker = {
    ltp: 0,
    best_bid: 0,
    best_ask: 0,
  };
  private funding = {
    fundingRate: 0,
    indicativeFundingRate: 0,
    fundingTimestamp: 0,
  };
  constructor() {
    super();
    const channels = ['orderBookL2:XBTUSD', 'instrument:XBTUSD', 'trade:XBTUSD'];
    this.realtime = new Realtime(channels);
    this.realtime.on('orderbook', (data) => {
      this.orderbook._setData(data);
      this.emit('orderbook', this.orderbook);
    });
    this.realtime.on('instrument', (data) => {
      // TODO: forEachにする必要あり？
      const { lastPrice, bidPrice, askPrice, fundingRate, indicativeFundingRate, fundingTimestamp } = data.data[0];
      if (fundingRate || indicativeFundingRate || fundingTimestamp) {
        if (fundingRate) {
          this.funding.fundingRate = fundingRate;
        }
        if (indicativeFundingRate) {
          this.funding.indicativeFundingRate = indicativeFundingRate;
        }
        if (fundingTimestamp) {
          this.funding.fundingTimestamp = Date.parse(fundingTimestamp);
        }
        this.emit('funding', this.funding);
      }
      if (lastPrice || bidPrice || askPrice) {
        if (lastPrice) {
          this.ticker.ltp = lastPrice;
        }
        if (bidPrice) {
          this.ticker.best_bid = bidPrice;
        }
        if (askPrice) {
          this.ticker.best_ask = askPrice;
        }
        this.emit('ticker', this.ticker);
      }
    });
    this.realtime.on('trade', (data) => {
      if (data.action === 'insert') {
        this.emit('trade', data.data);
      }
    });
  }
}
